module.exports = __webpack_public_path__ + "img/contact.0ad23236.png";